import { TRESPONSE_EFFICIENCY_CONFIG } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const FACTORY_EFFICIENCY_CONFIG_TABLE_MODEL = {
  createModel: (items: TRESPONSE_EFFICIENCY_CONFIG) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'CLUSTER',
          },
          {
            type: 'TEXT_CELL',
            text: 'FACTORY NAMES',
          },
          {
            type: 'TEXT_CELL',
            text: 'EFFICIENCY',
            widthInPx: 220,
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.cluster,
              metadata: {
                keyName: 'cluster',
              },
            },
            {
              type: 'TEXT_CELL',
              text: item.factory_name,
              metadata: {
                keyName: 'factoryName',
              },
            },
            {
              type: 'LABELLED_TOGGLE_CELL',
              selectedValue: item.efficiency_method,
              isDisabled: !item.editable,
              options: {
                toggleOption1: {
                  value: 'MULTIPLICATIVE',
                  label: 'Multiplicative',
                },
                toggleOption2: {
                  value: 'ABSOLUTE',
                  label: 'Absolute',
                },
              },
              metadata: {
                keyName: 'efficiencyMethod',
              },
            },
          ],
        };
      },
    );
  },
};
